import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import useWindowSize from '../../../../helpers/hooks/useWindowSize';
import { numberWithCommas, tryParseJSON } from '../../../../utils';
import { GUEST_PATH, LOCAL_CART, LOCAL_COUPON, LOCAL_COUPON_VOUCHERS } from '../../../../constants';

import images from '../../../../assets/images';
import { actionSetCart, actionAddCartCoupon, actionSetCartCouponVouchers } from './actions';

const CartInfo = () => {
     const dispatch = useDispatch();
     const cartItems = useSelector((state) => state.subscriber.cart.items);
     const cartLocal = tryParseJSON(localStorage.getItem(LOCAL_CART));

     const { width } = useWindowSize();
     const isMobile = useMemo(() => width < 1200, [width]);

     const fetchCart = () => {
          if (cartItems.length === 0 && cartLocal) {
               dispatch(actionSetCart(cartLocal));
               dispatch(actionAddCartCoupon(tryParseJSON(localStorage.getItem(LOCAL_COUPON))));
          }
     };
     useEffect(fetchCart, []); // eslint-disable-line react-hooks/exhaustive-deps

     return (
          <div className="cart-icon">
               <Link to={GUEST_PATH.CART}>
                    <img src={isMobile ? images.cartIcon : images.cartIconThin} alt="Cart Icon" />
               </Link>
               {cartItems.length > 0 && cartLocal && <span className="card-number">{cartItems.length}</span>}
          </div>
     );
};

const CartInfoWithPrice = () => {
     const dispatch = useDispatch();
     const cart = useSelector((state) => state.subscriber.cart.cart);
     const cartItems = useSelector((state) => state.subscriber.cart.items);

     const { width } = useWindowSize();
     const isMobile = useMemo(() => width < 1200, [width]);

     const cartLocal = tryParseJSON(localStorage.getItem(LOCAL_CART));

     const couponVouchersLocal = tryParseJSON(localStorage.getItem(LOCAL_COUPON_VOUCHERS)) || [];

     const fetchCart = () => {
          if (cartItems.length === 0 && cartLocal) {
               dispatch(actionSetCart(cartLocal));
               dispatch(actionAddCartCoupon(tryParseJSON(localStorage.getItem(LOCAL_COUPON))));
               if (couponVouchersLocal?.length) dispatch(actionSetCartCouponVouchers(couponVouchersLocal));
          }
     };
     useEffect(fetchCart, []); // eslint-disable-line react-hooks/exhaustive-deps

     return (
          <>
               {cartItems.length > 0 && cartLocal && (
                    <Link className="cart-total" to={GUEST_PATH.CART}>
                         ${numberWithCommas(cart.total)}
                    </Link>
               )}
               <div className="cart-icon">
                    <Link to={GUEST_PATH.CART}>
                         <img src={isMobile ? images.cartIcon : images.cartIconThin} alt="Cart Icon" />
                    </Link>
                    {cartItems.length > 0 && cartLocal && <span className="card-number">{cartItems.length}</span>}
               </div>
          </>
     );
};

export { CartInfo, CartInfoWithPrice };
